import { render } from "./Spinner.vue?vue&type=template&id=0801155e&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=0801155e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0801155e"

export default script